import React, { useState } from 'react';
import { Modal, Button, FormControl, InputGroup, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { REJECTION_REASON_MIN_CHARACTERS } from '../../assets/constants';

export const RejectionModal = ({ showRejectModal, handleClose, rejectDoc, rejectReason, certificateSelected, onChange, rejectionOptions = [] }) => {
    const [selectedOption, setSelectedOption] = useState(null);
    const { t } = useTranslation();

    const hasRejectionOptions = rejectionOptions.length > 0;

    const emptyRejectionOptionReason = hasRejectionOptions && !selectedOption;
    const emptyRejectionReason = !hasRejectionOptions && (rejectReason.length < REJECTION_REASON_MIN_CHARACTERS);
    
    const hasError = emptyRejectionOptionReason || emptyRejectionReason;

    const changeSelectedOption = (e) => {
        const selectedOptionItem = rejectionOptions.find(option => option.Id === e.target.value);
        
        setSelectedOption(selectedOptionItem);
    }
    
    return (
        <Modal show={showRejectModal} onHide={handleClose}>
            <Modal.Header closeButton>
                {certificateSelected && <Modal.Title>{t('documents.reject-document')}</Modal.Title>}
            </Modal.Header>
            <Modal.Body>
                <p>{t('documents.reject-document-question')}</p>
                {
                    hasRejectionOptions &&
                    <>
                        <Form.Group
                                onChange={changeSelectedOption}
                                >
                                <Form.Control
                                    as="select"
                                    id="optionsSelection"
                                    size="sm"
                                    defaultValue={selectedOption ? selectedOption.id : ''}
                                >
                                    <option value=''></option>
                                    {
                                        rejectionOptions.map((option) => (
                                            <option value={option.Id}>{option.Text}</option>
                                        ))
                                    }
                                </Form.Control>
                            </Form.Group>
                            {
                                emptyRejectionOptionReason && <span className="rejection-error">
                                    {t("documents.rejection-reason-validation")}
                                </span>
                            }
                    </>
                }
                <InputGroup>
                    <InputGroup.Prepend>
                        <InputGroup.Text>{t('documents.reject-reason')}</InputGroup.Text>
                    </InputGroup.Prepend>
                    <FormControl
                        as="textarea"
                        maxLength="450"
                        placeholder={t('documents.reject-reason-placeholder')}
                        value={rejectReason || ''}
                        onChange={onChange}
                        className="reject-reason"
                    />
                </InputGroup>
                {
                    (emptyRejectionReason) && <span className="rejection-error">
                        {t("documents.rejection-reason-validation")}
                    </span>
                }
            </Modal.Body>
            <Modal.Footer>
                <div className="centered-buttons">
                <Button
                    className="reject"
                    onClick={handleClose}
                >
                    {t('general.cancel')}
                </Button>
                <Button
                    disabled={hasError}
                    variant="primary"
                    onClick={() => rejectDoc(selectedOption, rejectReason)}
                    style={{ marginLeft: 20 }}
                >
                    {t('general.confirm')}
                </Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
};
